export default __webpack_public_path__ + "static/media/susie.f8afc9ed.png";